import { AnyAction } from 'redux';
import { Reference } from '@/types';
import { getParams } from '@/utils/params';
import { getViewForPreview } from '@/model/draft/getViewForPreview';
import { getDraftDispatch } from '@/redux/draft/draftDispatch';
import { getCurrentAppearance } from '@/redux/draft/getters/getCurrentAppearance';
import { getDraft } from '@/redux/draft/getters/getDraft';
import { getProductType } from '@/redux/draft/getters/getProductType';
import { writeToMemento } from '@/redux/draft/memento/writeToMemento';
import { Thunk } from '@/redux/types';
import { unsetBasketItemIdAction } from '@/components/draft/draftState/actions/unsetBasketItemIdAction';
import { withoutHistory } from '@/components/draft/draftState/history/withoutHistory';
import { getAllBasketItemsWithSameProductId } from '../getters/getAllBasketItemsWithSameProductId';
import { addToExternalBasket } from '../utils/addToExternalBasket';

const removeBasketItem = (itemId: string) => {
  return new Promise<void>((resolve, reject) => {
    const { removeBasketItem } = getParams();
    if (removeBasketItem) {
      removeBasketItem(itemId, (err) => {
        if (err) {
          reject(err);
        }
        resolve();
      });
    } else {
      resolve();
    }
  });
};

export const addToBasketAction =
  (
    selectedSizes: Record<string, number>,
    productReference: Reference,
    onAdded?: () => void
  ): Thunk<Promise<any>, AnyAction> =>
  async (dispatch, getState) => {
    const state = getState();
    const { basketItemId } = getDraft(state);

    // remove ALL basketItems with the same productId
    if (basketItemId) {
      const basketItemsToRemove = getAllBasketItemsWithSameProductId(state, basketItemId);
      if (basketItemsToRemove.length) {
        const basketItemIds = basketItemsToRemove.map((item) => item.id);
        for (const basketItemId of basketItemIds) {
          await removeBasketItem(basketItemId);
        }
      }
    }

    const appearance = getCurrentAppearance(state);
    const productType = getProductType(state);
    const view = getViewForPreview(state.draft);

    await addToExternalBasket(selectedSizes, productReference, productType, appearance, view);
    onAdded?.();

    getDraftDispatch(state)(withoutHistory(unsetBasketItemIdAction));

    writeToMemento(state, productReference);
  };
